import { get, toLower } from 'lodash'
const { MAP_OVERRIDE } = process.env

function isMapEnabled(communityConfig) {
  return get(communityConfig, 'mapEnabled') || toLower(MAP_OVERRIDE) === 'true'
}

export default isMapEnabled
